import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";

/**
 * Props
 * -----
 * id            : string   -> Unique identifier (required for Reactstrap)
 * title         : string   -> Text to display on the header
 * body          : ReactNode|()=>ReactNode -> Content rendered inside the accordion
 * defaultOpen   : boolean  -> Whether the accordion starts open (default = false)
 * flush         : boolean  -> Removes default background, borders, and some rounded corners (default = false)
 * disabled      : boolean  -> Disables user interaction (default = false)
 * className     : string   -> Additional custom classes
 * -------------------------------------------------------
 */
export default function CustomAccordion({
  id = "0",
  title = "Accordion Title",
  body,
  defaultOpen = false,
  flush = false,
  disabled = false,
  className = "",
}) {
  const [open, setOpen] = useState(() => (defaultOpen ? [id] : []));

  const toggle = (accordionId) => {
    if (disabled) return;
    setOpen((prevOpen) =>
      prevOpen.includes(accordionId) ? [] : [accordionId]
    );
  };

  // Helper to support both function and node children in `body`
  const renderBody = () => (typeof body === "function" ? body() : body);

  // Combine class names
  const accordionClasses = [
    "custom-accordion",
    flush && "flush",
    disabled && "disabled",
    className
  ].filter(Boolean).join(" ");

  return (
    <Accordion
      flush={flush}
      open={open}
      toggle={toggle}
      className={accordionClasses}
    >
      <AccordionItem>
        <AccordionHeader targetId={id}>
          {title}
        </AccordionHeader>
        <AccordionBody accordionId={id}>
          <div className="accordion-content">
            {renderBody()}
          </div>
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );
}